import { render, staticRenderFns } from "./UpdateUsername.vue?vue&type=template&id=4e6dd7d4"
import script from "./UpdateUsername.vue?vue&type=script&lang=ts"
export * from "./UpdateUsername.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports